import axios from 'api/axios'

async function transformShortUrl (url) {
  const activityUrl = `/v1/front/short_url`
  return axios({
    method: 'POST',
    url: activityUrl,
    data: {
      url: url
    }
  })
}
export {transformShortUrl}



// WEBPACK FOOTER //
// ./src/api/transformShortUrl.js